import { defineStyles } from "@pandacss/dev";

const textFieldStyles = defineStyles({
  textStyle: "paragraph.m.regular",
  color: "content.neutral.base.subtle",
  _placeholder: {
    color: "content.neutral.base.subtlest",
  },
  _disabled: {
    color: "content.neutral.base.disable",
    cursor: "not-allowed",
    _placeholder: {
      color: "content.neutral.base.disable",
    },
  },
});

export default textFieldStyles;
